import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomVendorReportingComponent } from './components/custom-vendor-reporting/custom-vendor-reporting.component';
import {
  AuthGuard,
  CmsConfig,
  ConfigModule,
  I18nModule,
  OccConfig,
  UrlModule,
  provideConfig,
} from '@spartacus/core';
import {
  CmsPageGuard,
  FormErrorsModule,
  IconModule,
  PageLayoutComponent,
  SpinnerModule,
  LayoutConfig
} from '@spartacus/storefront';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import {
  customVendorReportingFeatureKey,
  customVendorReportingReducer,
} from './store/custom-vendor-reporting.reducer';
import { CustomVendorReportingEffects } from './store/custom-vendor-reporting.effects';
import { CustomVendorReportingAdapter } from './custom-vendor-reporting.adapter';
import { CustomVendorReportingDetailsComponent } from './components/custom-vendor-reporting-details/custom-vendor-reporting-details.component';
import { CustomCanonVendorReportingDetailsComponent } from './components/custom-canon-vendor-reporting-details/custom-canon-vendor-reporting-details.component';
import { CustomVendorReportingInstructionsComponent } from './components/custom-vendor-reporting-instructions/custom-vendor-reporting-instructions.component';

import { CustomVendorReportDataEvaluationComponent } from './components/custom-vendor-report-data-evaluation/custom-vendor-report-data-evaluation.component';
@NgModule({
  declarations: [
    CustomVendorReportingComponent,
    CustomVendorReportingDetailsComponent,
    CustomCanonVendorReportingDetailsComponent,
    CustomVendorReportingInstructionsComponent,
    CustomVendorReportDataEvaluationComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    SpinnerModule,
    FormsModule,
    FormErrorsModule,
    ReactiveFormsModule,
    NgSelectModule,
    RouterModule,
    UrlModule,
    IconModule,
    ConfigModule.withConfig({
      backend: {
        occ: {
          endpoints: {
            customVendorReportingOverview: '/myrio/vendorreport/search',
            customVendorReportingDetailsCSVUpload: '/myrio/vendorreport/upload',
            manufacturerMappingList: '/myrio/vendorreport/manufacturerMappings',
            customCanonVendorReportingDetails: '/myrio/vendorreport/canon/details',
            customCanonVendorReportingDetailsUpdate: '/myrio/vendorreport/canon/details',
            customCanonVendorReportingDetailsDelete: '/myrio/vendorreport/canon/details',
            customRioVendorReportingOverview: '/myrio/vendorreport/dataevaluation/search',
            customRioDataExport: '/myrio/vendorreport/exportRioData',
            branchesList: '/myrio/vendorreport/branches',
          },
        },
      },
    } as OccConfig),
    StoreModule.forFeature(
      customVendorReportingFeatureKey,
      customVendorReportingReducer
    ),
    EffectsModule.forFeature([CustomVendorReportingEffects]),
    ConfigModule.withConfig({
      layoutSlots: {
        RioVendorReportDashboardPageTemplate: {
              slots: [
                  'LeftContentSlot',
                  'RightContentSlot',
              ]
          },
        RioVendorReportDataEvaluationPage: {
          slots: [
              'LeftContentSlot',
          ]
      }
      },
  } as LayoutConfig),  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        VendorReportingOverviewComponent: {
          component: CustomVendorReportingComponent,
          guards: [AuthGuard],
        },
        VendorReportingDetailsComponent: {
          component: CustomVendorReportingDetailsComponent,
          guards: [AuthGuard],
        },
        RioVendorReportDashboardOverviewComponent: {
          component: CustomVendorReportingComponent
        },
        RioDataEvaluationComponent: {
          component: CustomVendorReportDataEvaluationComponent
        },
      },
    }),
    {
      provide: CustomVendorReportingAdapter,
      useClass: CustomVendorReportingAdapter,
    },
  ],
})
export class CustomVendorReportingModule {}
